export default __webpack_public_path__ + "static/combination-of-different-series-types-f3c9dca75bd521c5289500eb0d0a80e1.png";